<template>
  <b-modal size="xl" scrollable content-class="addDeviceModal" v-model="isShow">
    <template #modal-title>
      {{ $t('Add Device') }}
    </template>
    <b-container fluid class="addDevice">
      <b-card-group deck>
        <b-card
          :title="device.name"
          :img-src="device.imageUrl"
          img-top
          v-for="device in availableDevices"
          :key="device.type"
          @click="selectDevice(device)"
          :class="{ selected: device.type === selectedDevice.type }"
        >
          <i class="fa fa-check-circle" aria-hidden="true"></i>
        </b-card>
      </b-card-group>
    </b-container>
    <template #modal-footer="{ ok }">
      <div class="float-right">
        <b-button size="sm" @click="ok">
          {{ $t('Close') }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="add"
          :disabled="!selected"
        >
          {{ $t('Add') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import storage from '@/libs/storage'

export default {
  name: 'AddDevicePopup',
  data() {
    return {
      isShow: false,
      isSmallImage: true,
      availableDevices: [],
      selectedDevice: {}
    }
  },
  computed: {
    ...mapState(['devices', 'myDevices', 'language', 'addDevicePopupData']),
    selected() {
      return _.size(this.selectedDevice) > 0
    }
  },
  methods: {
    ...mapMutations(['setMyDevices']),
    add() {
      this.isShow = false
      const myDevices = _.concat(this.myDevices, this.selectedDevice)
      this.setMyDevices(myDevices)
      storage.local.setItem('my_devices', JSON.stringify(myDevices))
    },
    selectDevice(device) {
      this.selectedDevice = device
    }
  },
  watch: {
    addDevicePopupData() {
      if (this.addDevicePopupData.isShow) {
        this.isShow = true
        this.availableDevices = _.differenceBy(
          this.devices,
          this.myDevices,
          'type'
        )
        this.selectedDevice = {}
      } else {
        this.isShow = false
      }
    }
  }
}
</script>

<style>
.addDevice .card-deck .card {
  min-width: 150px;
  max-width: 150px;
  margin-bottom: 20px;
  cursor: pointer;
}

.addDevice .card-deck .card:hover {
  border: solid 1px #4242e2;
  outline: 1px solid #1616c4;
  outline-offset: -2px;
  opacity: 0.5;
}

.addDevice .card-deck .card .card-body {
  position: relative;
  padding: 5px 10px;
}

.addDevice .card-deck .card .card-title {
  font-size: 15px;
  margin-bottom: 0;
}

.addDevice .card-deck .card svg {
  position: absolute;
  display: none;
  top: -140px;
  font-size: 20px;
  color: #3160b7;
  background-color: white;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}

.addDevice .card-deck .card.selected svg {
  display: block;
}
</style>
